"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayOfUUID = exports.isArrayOfStringNotEmpty = exports.isStringNotEmpty = exports.generateRegExpFromString = exports.convertListRegexpToArray = exports.compareStrings = void 0;
const __1 = require("..");
const compareStrings = (compareThis, compareWith) => {
    let result = false;
    compareThis = '' + (compareThis || '');
    compareWith = '' + (compareWith || '');
    const regex = (0, __1.generateRegExpFromString)(compareWith);
    if (regex) {
        result = regex.test(compareThis);
    }
    return result;
};
exports.compareStrings = compareStrings;
const convertListRegexpToArray = (value) => {
    if (typeof value === 'string') {
        if (value.startsWith('^(') && value.endsWith(')$')) {
            return (0, __1.splitRegexpGroupVariationsIntoArray)(value);
        }
        else {
            return [value];
        }
    }
    return value;
};
exports.convertListRegexpToArray = convertListRegexpToArray;
/**
 * Эта функция добавляется в Conditions чтобы её можно было использовать снаружи
 * В случае необходимости можно переопределить экспортируемую функцию чтобы изменить функционал
 */
var string_parser_class_1 = require("../regexp/utils/string-parser.class");
Object.defineProperty(exports, "generateRegExpFromString", { enumerable: true, get: function () { return string_parser_class_1.generateRegExpFromString; } });
const isStringNotEmpty = (potentialString) => !!(typeof potentialString === 'string' && potentialString);
exports.isStringNotEmpty = isStringNotEmpty;
const isArrayOfStringNotEmpty = (array) => {
    if (!Array.isArray(array)) {
        return false;
    }
    return !!array.filter(exports.isStringNotEmpty).length;
};
exports.isArrayOfStringNotEmpty = isArrayOfStringNotEmpty;
const isArrayOfUUID = (array) => {
    if (!Array.isArray(array)) {
        return false;
    }
    return !!array.filter(__1.isUUID).length;
};
exports.isArrayOfUUID = isArrayOfUUID;
//# sourceMappingURL=utils.js.map